import { useEffect, useState } from "react";
import "./styles.css";

export default function GalleryCarousel() {
  const images = [
    {
      src: "../images/empleados/image5.jpg",
      alt: "Equipo Supre",
    },
    {
      src: "../images/empleados/image4.jpg",
      alt: "Equipo Supre",
    },
    {
      src: "../images/empleados/image6.jpg",
      alt: "Equipo Supre",
    },
    {
      src: "../images/empleados/image3.jpg",
      alt: "Equipo Supre",
    },
    {
      src: "../images/empleados/image2.jpg",
      alt: "Equipo Supre",
    },
    {
      src: "../images/empleados/image1.jpg",
      alt: "Clientes Supre",
    },
  ];

  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 3500); // Cambia cada 3.5 segundos
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <section className="gallery-section">
      <h2 className="o-heading-3 c-block-5__m2">Nuestra esencia</h2>

      <p className="gallery-description">
        En Supre creemos en el poder de las personas. Estas imágenes reflejan el
        compromiso, la pasión y la alegría de un equipo que trabaja unido para
        ayudarte a alcanzar tus sueños.
      </p>

      {/* Carrusel */}
      <div className="carousel-scale">
        <div className="carousel-container">
          <div
            className="carousel-track"
            style={{ transform: `translateX(-${current * 100}%)` }}
          >
            {images.map((img, i) => (
              <div className="gallery-item" key={i}>
                <img src={img.src} alt={img.alt} />
              </div>
            ))}
          </div>
        </div>
      </div>
      <p className="quote">
        “El éxito de Supre está en las personas que lo hacen posible cada día.”
      </p>
    </section>
  );
}
